<template>
<div>
    <div class="row">
        <div class="col-auto">
            <button class="btn btn-default btn-lg" @click="chooseFile">
                {{resource('DmVisualizer_ChangeInfo_Select_Logo_Button_Text')}}
            </button>
        </div>
        <div class="col-6 preview" align="center">
            <input 
                type="file" 
                id="file-upload" 
                name ="file-upload" 
                accept="image/*"
                hidden
                ref="upload"
                @change="uploadFile"
            />

            <img ref="image" name="image-preview" id="image-preview"/>
        </div>
    </div>
</div>

</template>

<script>
import $ from 'jquery';
import api from '../../../../../Api/dm-visualizer';
import growler from "../../../../../Util/growler";

//mixins
import resourceMixin from '../../../../../Util/Mixins/resources';

export default {
    name: 'info-file-upload',
    mixins: [resourceMixin],
    methods: {
        chooseFile() {
            const vm = this;
            
            if(!vm.isEnabled)
                return;

            const upload = $(vm.$refs.upload);
            upload.click();
        },
        uploadFile(e) {
            const vm = this;
            const file = e.target.files[0];

            api.uploadLogo(file).then(
                path => {vm.filePath = path; },
                err => growler.error(err.join('\n'))
            );
        }
    },
    watch: {
        filePath(value) {
            const vm = this;
            const image = $(vm.$refs.image);
            image.attr('src', `${api.endpoint}GetLogo?filename=${value}`);
            
            vm.$emit('input', value);
        }
    },
    data() {
        return {
            filePath: null
        }
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}
</script>

<style scoped src="../../../Style/info-file-upload.scss" lang ="scss">

</style>
